import React from 'react';

const Blog = () => {
  return (
    <section className='py-32 bg-gray-50 dark:bg-gray-900 relative'>
      <div className='container mx-auto px-8 max-w-7xl'>
        <h2 className='text-5xl font-montserrat font-bold bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent mb-6'>
          Блог
        </h2>
        <p className='text-xl text-gray-600 dark:text-gray-400 mb-8'>
          Читайте наши последние статьи и обновления о технологиях и инновациях.
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          <div className='bg-white dark:bg-gray-800/70 p-6 rounded-2xl shadow-md'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Технологические тренды</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Узнайте о новейших тенденциях в мире технологий.
            </p>
          </div>
          <div className='bg-white dark:bg-gray-800/70 p-6 rounded-2xl shadow-md'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Истории успеха</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Истории наших клиентов и их достижений.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
